<template>
  <div class="table-page-search-wrapper">
    <a-form :layout="layout">
      <a-row :gutter="gutter">
        <a-col :md="spanMd" :sm="24">
          <a-form-item label="被考核人">
            <a-input
              placeholder="请输入被考核人姓名"
              :allowClear="true"
              autocomplete="off"
              v-model="searchModel.userName"
            />
          </a-form-item> </a-col
        ><a-col :md="spanMd" :sm="24">
          <a-form-item label="考核状态">
            <a-select v-model="searchModel.status" :allowClear="true" placeholder="请选择考核状态">
              <a-select-option v-for="(item, index) in scoreStatusList" :value="item.id" :key="index">
                {{ item.label }}
              </a-select-option>
            </a-select>
          </a-form-item> </a-col
        ><a-col :md="spanMd" :sm="24">
          <a-form-item label="考核结果">
            <a-select v-model="searchModel.scoreLevel" :allowClear="true" placeholder="请选择考核结果">
              <a-select-option v-for="(item, index) in assessResultList" :key="index" :value="item.code">
                {{ item.name }}
              </a-select-option>
            </a-select>
          </a-form-item> </a-col
        ><a-col :md="4" :sm="24">
          <span class="table-page-search-submitButtons">
            <a-button type="primary" @click="search">查询</a-button>
            <a-button style="margin-left: 8px" @click="clearSearch">重置</a-button>
          </span>
        </a-col>
      </a-row>
    </a-form>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'assessmentSearchForm',
  mounted() {
  },
  computed: {
    // 得到vuex里面得到的数据
    ...mapGetters(['assessResultList']),
  },
  data() {
    return {
      layout: 'inline',
      gutter: 20,
      spanMd: 8,
      spanSm: 24,
      scoreStatusList: [ // 考核状态
        { id: 0, label: '已考核'},
        { id: 1, label: '待考核'},
        { id: 9, label: '考核忽略'}
      ],
      searchModel: {},
    }
  },
  methods: {
    // 点击查询按钮
    search() {
      for (var key in this.searchModel) {
        if (this.searchModel[key] === undefined || this.searchModel[key] === null || this.searchModel[key] === '') {
          delete this.searchModel[key]
        }
      }
      this.$emit('setSearchCondition', this.searchModel)
    },
    // 点击重制按钮
    clearSearch() {
      this.searchModel.userName = ''
      this.searchModel.status = undefined
      this.searchModel.scoreLevel = ''

      this.$emit('clearSearch', this.searchModel)
    }
  },
}
</script>

<style scoped lang="less"></style>

